import { render } from "./parity.vue?vue&type=template&id=ba061ef4&scoped=true"
import script from "./parity.vue?vue&type=script&lang=js"
export * from "./parity.vue?vue&type=script&lang=js"

import "./parity.vue?vue&type=style&index=0&id=ba061ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba061ef4"]])

export default __exports__